import { Container } from "@brightagency/headstart-common";
import React, { useRef, MutableRefObject, useEffect } from "react";
import { mergeRefs } from "../../../utils";
import { Outer, Track, Items, Item } from "./styled";

export interface Props {
    itemWidth: number;
    itemGutter: number;
    scrollingRef?: MutableRefObject<HTMLDivElement | null>;
    onScrolledToEnd?: () => void;
    isLoading?: boolean;
}

export const Carousel: React.FC<Props> = ({ onScrolledToEnd, ...props }) => {
    const ref = useRef<HTMLDivElement | null>(null);

    // Scrolled to end handler
    useEffect(() => {
        if (ref) {
            const el = ref.current;
            if (!el) return;
            const handle = () => {
                if (el.scrollWidth - el.offsetWidth === el.scrollLeft) {
                    if (onScrolledToEnd) {
                        onScrolledToEnd();
                    }
                }
            };
            el.addEventListener("scroll", handle);
            return () => {
                el.removeEventListener("scroll", handle);
            };
        }
    }, [onScrolledToEnd, ref]);

    return (
        <Outer
            style={{
                opacity: props.isLoading ? 0.5 : 1,
                transition: "200ms ease all",
            }}
        >
            <Track className="carousel-track" ref={mergeRefs([ref, props.scrollingRef])}>
                <Container className="carousel-container">
                    <Items>
                        {React.Children.toArray(props.children)
                            .filter(Boolean)
                            .map((child, index, arr) => (
                                <Item
                                    key={index}
                                    width={props.itemWidth}
                                    gutter={props.itemGutter}
                                    last={index === arr.length - 1}
                                    className="carousel-item"
                                >
                                    {child}
                                </Item>
                            ))}
                    </Items>
                </Container>
            </Track>
        </Outer>
    );
};
